import { FormattedMessage } from 'react-intl';
import { ThumbsDown, ThumbsUp } from 'lucide-react';

import { Avatar, AvatarFallback } from '@/components/ui/avatar';
// Badge component not available, using inline styling
import { Separator } from '@/components/ui/separator';
import { type UserFeedback } from '@/lib/queries/rca/mockData';

import { formatDate, getInitials } from './FeedbackUtils';

export { CommentForm, RatingButtons } from './FeedbackUtils';
export function ExistingFeedback({
  feedback,
}: {
  feedback: UserFeedback;
}): JSX.Element {
  return (
    <div className="space-y-2">
      <p className="text-sm font-medium">
        <FormattedMessage id="rca.feedback.yourFeedback" />
      </p>
      <div className="flex items-center gap-2">
        {feedback.rating === 'positive' ? (
          <ThumbsUp className="w-4 h-4 text-green-600" />
        ) : (
          <ThumbsDown className="w-4 h-4 text-red-600" />
        )}
        <span className="text-sm">
          <FormattedMessage
            id={
              feedback.rating === 'positive'
                ? 'rca.feedback.ratedPositive'
                : 'rca.feedback.ratedNegative'
            }
          />
        </span>
      </div>
      {Boolean(feedback.comment) && feedback.comment!.length > 0 && (
        <p className="text-sm text-gray-700 dark:text-gray-300 bg-gray-50 dark:bg-gray-800 p-3 rounded">
          {feedback.comment!}
        </p>
      )}
    </div>
  );
}
export function TeamFeedback({
  feedbackList,
}: {
  feedbackList: UserFeedback[];
}): JSX.Element {
  return (
    <>
      <Separator />
      <div className="space-y-3">
        <p className="text-sm font-medium">
          <FormattedMessage id="rca.feedback.teamFeedback" />
        </p>
        <div className="space-y-3">
          {feedbackList.map(feedback => (
            <div key={feedback.id} className="flex gap-3">
              <Avatar className="w-8 h-8">
                <AvatarFallback className="text-xs">
                  {getInitials(feedback.userName)}
                </AvatarFallback>
              </Avatar>
              <div className="flex-1 space-y-1">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium">
                    {feedback.userName}
                  </span>
                  {feedback.rating === 'positive' ? (
                    <ThumbsUp className="w-3 h-3 text-green-600" />
                  ) : (
                    <ThumbsDown className="w-3 h-3 text-red-600" />
                  )}
                  <span className="text-xs px-2 py-1 bg-gray-100 dark:bg-gray-700 rounded">
                    {feedback.source}
                  </span>
                  <span className="text-xs text-gray-500">
                    {formatDate(feedback.createdAt)}
                  </span>
                </div>
                {Boolean(feedback.comment) && feedback.comment!.length > 0 && (
                  <p className="text-sm text-gray-700 dark:text-gray-300">
                    {feedback.comment!}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
